(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-cart"] && !Shopify.designMode) return;
  try {
    
// El codigo de descuento se aplica navegando a /discount/CODE, que es la via
// que da Shopify sin app. Limitacion conocida: si el codigo no existe Shopify
// no devuelve ningun error, simplemente no aplica nada.
document.querySelectorAll('[data-bl-promo]').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var code = form.querySelector('input[name="code"]').value.trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-collection-grid"] && !Shopify.designMode) return;
  try {
    
// Con JS el orden se aplica al cambiar el select y sobra el boton; sin JS el
// boton se queda y el formulario sigue funcionando.
document.querySelectorAll('[data-bl-sort]').forEach(function (form) {
  var go = form.querySelector('.bl-colgrid__go');
  if (go) go.hidden = true;
  var sel = form.querySelector('select');
  if (sel) sel.addEventListener('change', function () { form.submit(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-method"] && !Shopify.designMode) return;
  try {
    
// Method of Use. La lista manda: la ficha grande es una vitrina que se rellena
// con el paso activo, y ese paso se oculta de la lista para no repetirse.
// Sin JS la vitrina no se pinta y la lista se lee entera.
document.querySelectorAll('[data-bl-method]').forEach(function (root) {
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-bl-method-item]'));
  if (!items.length) return;

  var card = root.querySelector('[data-bl-method-featured]');
  var list = root.querySelector('[data-bl-method-list]');
  var nav = root.querySelector('[data-bl-method-nav]');
  if (!card || !list) return;

  var img = card.querySelector('[data-bl-method-img]');
  var num = card.querySelector('[data-bl-method-num]');
  var disc = card.querySelector('[data-bl-method-disc]');
  var title = card.querySelector('[data-bl-method-title]');
  var text = card.querySelector('[data-bl-method-text]');

  function show(btn) {
    var li = btn.closest('.bl-method__item');
    var src = btn.dataset.src;

    img.parentElement.hidden = !src;
    if (src) {
      img.src = src;
      img.alt = btn.querySelector('.bl-method__title').textContent;
    }
    num.textContent = btn.dataset.num;
    // el disco lleva solo la cifra: «STEP 3» -> «3»
    if (disc) disc.textContent = (btn.dataset.num || '').replace(/\D+/g, '');
    title.textContent = btn.querySelector('.bl-method__title').textContent;
    text.innerHTML = btn.querySelector('[data-bl-method-src]').innerHTML;

    items.forEach(function (o) { o.closest('.bl-method__item').hidden = false; });
    li.hidden = true;
  }

  card.hidden = false;
  root.classList.add('is-ready');
  if (nav) nav.hidden = false;

  items.forEach(function (btn) {
    btn.addEventListener('click', function () { show(btn); });
  });

  if (nav) {
    nav.querySelectorAll('[data-bl-method-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        list.scrollBy({ top: 200 * parseInt(b.dataset.blMethodScroll, 10), behavior: 'smooth' });
      });
    });
  }

  show(items[0]);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-page-header"] && !Shopify.designMode) return;
  try {
    
// Filtra los acordeones bl-faq de la pagina. Los <details> ya son buscables
// con Cmd+F en navegadores modernos; esto es para el campo que pide el diseno.
(function () {
  var input = document.querySelector('[data-bl-faq-search]');
  if (!input) return;
  var count = document.querySelector('[data-bl-faq-count]');
  var items = [].slice.call(document.querySelectorAll('.bl-faq__item'));
  if (!items.length) return;

  function apply() {
    var q = input.value.trim().toLowerCase();
    var shown = 0;

    items.forEach(function (item) {
      var match = !q || item.textContent.toLowerCase().indexOf(q) !== -1;
      item.hidden = !match;
      if (match) shown++;
      // al buscar se abren para que se vea donde esta la coincidencia
      if (q) item.open = match;
    });

    // una categoria sin resultados desaparece entera, titulo incluido
    document.querySelectorAll('.bl-faq').forEach(function (sec) {
      var any = [].slice.call(sec.querySelectorAll('.bl-faq__item')).some(function (i) { return !i.hidden; });
      sec.hidden = q ? !any : false;
    });

    // "1 result" en singular; y el contador se ve al buscar, para que cero
    // resultados no deje la pagina en blanco sin explicacion
    if (count) {
      count.textContent = shown === 1 ? '1 result' : shown + ' results';
      count.hidden = !q;
    }
  }

  input.addEventListener('input', apply);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-popup"]) return;
  try {
    
// Una vez por sesion. <dialog>.showModal() ya da Escape, foco atrapado y
// backdrop, asi que aqui solo queda decidir CUANDO se abre.
(function () {
  var el = document.querySelector('[data-bl-popup]');
  if (!el || typeof el.showModal !== 'function') return;

  var designMode = window.Shopify && window.Shopify.designMode;

  function open() {
    if (!el.open) el.showModal();
  }

  if (designMode) {
    // en el editor no se abre solo: taparia el trabajo del cliente
    document.addEventListener('shopify:section:select', function (e) {
      if (el.closest('.shopify-section') === e.target) open();
    });
    document.addEventListener('shopify:section:deselect', function () {
      if (el.open) el.close();
    });
    return;
  }

  var key = el.dataset.key || 'bl-popup';
  try {
    if (sessionStorage.getItem(key)) return;
  } catch (err) {
    return; // sin sessionStorage no hay forma de no ser pesado: mejor no abrir
  }

  var delay = parseInt(el.dataset.delay, 10);
  window.setTimeout(function () {
    open();
    try { sessionStorage.setItem(key, '1'); } catch (err) {}
  }, isNaN(delay) ? 4000 : delay * 1000);

  // clic en el backdrop = cerrar. El <dialog> ocupa solo su caja, asi que un
  // clic cuyo punto cae fuera de esa caja es un clic en el backdrop.
  el.addEventListener('click', function (e) {
    if (e.target !== el) return;
    var r = el.getBoundingClientRect();
    var fuera = e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    if (fuera) el.close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-product-main"] && !Shopify.designMode) return;
  try {
    
// Galeria: la miniatura cambia la imagen grande. Sin esto el enlace abre la
// foto a tamano completo, que es una degradacion aceptable.
document.querySelectorAll('[data-bl-gallery]').forEach(function (root) {
  var main = root.querySelector('[data-bl-gallery-main]');
  if (!main) return;
  root.querySelectorAll('[data-bl-thumb]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      main.src = a.dataset.blThumb;
      main.alt = a.dataset.blAlt || main.alt;
      root.querySelectorAll('[data-bl-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
      a.setAttribute('aria-current', 'true');
    });
  });
});

// Pasos de cantidad. El input numerico ya funciona solo sin JS.
document.querySelectorAll('[data-bl-qty]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var next = (parseInt(input.value, 10) || min) + step * parseInt(btn.dataset.blQty, 10);
    input.value = Math.min(max, Math.max(min, next));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-quiz"] && !Shopify.designMode) return;
  try {
    
// Quiz de tipo de pelo, flujo del spec de Veronica (2026-08-12):
// preguntas -> contacto -> POST nativo -> resultado.
//
// Reglas: filtro fuerte (valor 'b_force') fuerza la formula B; si no,
// mayoria entre 'a' y 'b' ('none' no puntua); empate = mixto.
//
// El POST recarga la pagina a proposito (captcha de Shopify). El resultado
// viaja en sessionStorage y se pinta a la vuelta si el form confirmo el alta.
document.querySelectorAll('[data-bl-quiz]').forEach(function (root) {
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-bl-step]'));
  if (!steps.length) return;

  var total = steps.length;
  var section = root.closest('.bl-quiz');
  var stepLabel = root.querySelector('[data-bl-quiz-step]');
  var pct = root.querySelector('[data-bl-quiz-pct]');
  var fill = root.querySelector('[data-bl-quiz-fill]');
  var back = root.querySelector('[data-bl-quiz-back]');
  var next = root.querySelector('[data-bl-quiz-next]');
  var contact = root.querySelector('[data-bl-contact]');
  var leadAnswers = root.querySelector('[data-bl-lead-answers]');
  var leadResult = root.querySelector('[data-bl-lead-result]');
  var mixed = section.querySelector('[data-bl-quiz-mixed]');
  var outcomes = Array.prototype.slice.call(section.querySelectorAll('[data-bl-outcome]'));
  var results = section.querySelector('[data-bl-quiz-results]');
  var template = stepLabel ? stepLabel.textContent : '';
  var KEY = 'bl-quiz-lead';
  var i = 0; // 0..total-1 = preguntas; total = contacto

  root.classList.add('is-ready');
  if (results) results.hidden = true;

  function titleFor(key) {
    var card = section.querySelector('[data-bl-outcome="' + key + '"] .bl-quiz__outcome-title');
    return card ? card.textContent.trim() : key;
  }

  // Reglas 1-3 del spec sobre lo marcado ahora mismo en el DOM.
  function compute() {
    var a = 0, b = 0, forced = false, labels = [];
    steps.forEach(function (s) {
      var picked = s.querySelector('[data-bl-answer]:checked');
      if (!picked) return;
      var option = picked.closest('.bl-quiz__option');
      labels.push(option ? option.textContent.trim() : picked.value);
      if (picked.value === 'b_force') { forced = true; b += 1; }
      else if (picked.value === 'b') { b += 1; }
      else if (picked.value === 'a') { a += 1; }
    });
    var key = 'mixed';
    if (forced) key = 'b';
    else if (a !== b) key = a > b ? 'a' : 'b';
    return { key: key, labels: labels };
  }

  function showResult(key) {
    outcomes.forEach(function (card) {
      var win = key !== 'mixed' && card.dataset.blOutcome === key;
      card.classList.toggle('is-match', win);
      var badge = card.querySelector('[data-bl-quiz-badge]');
      if (badge) badge.hidden = !win;
      card.querySelectorAll('[data-bl-quiz-win]').forEach(function (el) { el.hidden = !win; });
    });
    if (mixed) mixed.hidden = key !== 'mixed';
    if (results) results.hidden = false;
    root.hidden = true;
  }

  function answered(n) {
    return !!steps[n].querySelector('[data-bl-answer]:checked');
  }

  function render() {
    var enContacto = i >= total;
    steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    if (contact) contact.classList.toggle('is-active', enContacto);
    var done = enContacto ? 100 : Math.round((i + 1) / total * 100);
    // el contador se escribe entero en el editor ("Question 1 of 5"): el primer
    // numero es la pregunta actual y el ultimo el total, en el idioma que sea
    if (stepLabel) stepLabel.textContent = template.replace(/\d+/, Math.min(i + 1, total)).replace(/\d+$/, total);
    if (pct) pct.textContent = done + '%';
    if (fill) fill.style.width = done + '%';
    // invisible y no enfocable, pero ocupando sitio: si no, Next salta a la izquierda
    if (back) { back.classList.toggle('is-hidden', i === 0); back.disabled = i === 0; }
    if (next) {
      next.hidden = enContacto; // en el contacto manda el «See my result» del form
      next.disabled = !enContacto && !answered(i);
    }
  }

  function fillLead() {
    var r = compute();
    if (leadAnswers) leadAnswers.value = r.labels.join(' | ');
    if (leadResult) leadResult.value = r.key === 'mixed' ? 'Mixed' : titleFor(r.key);
    try { sessionStorage.setItem(KEY, JSON.stringify(r)); } catch (err) {}
    return r;
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-bl-answer]')) render();
  });

  if (next) next.addEventListener('click', function () {
    if (!answered(i)) return;
    i += 1;
    if (i >= total) fillLead(); // paso de contacto: deja el lead listo
    render();
    var first = i < total ? steps[i].querySelector('[data-bl-answer]') : root.querySelector('#bl-quiz-name');
    if (first) first.focus();
  });

  if (back) back.addEventListener('click', function () {
    if (i === 0) return;
    i -= 1;
    render();
    var first = steps[i].querySelector('[data-bl-answer]');
    if (first) first.focus();
  });

  // refresca el lead justo antes de enviar, por si se volvio a cambiar algo
  var lead = root.querySelector('.bl-quiz__lead');
  if (lead) lead.addEventListener('submit', fillLead);

  // ¿venimos de un POST? El resultado espera en sessionStorage.
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) {}

  if (root.querySelector('[data-bl-posted]') && saved) {
    try { sessionStorage.removeItem(KEY); } catch (err) {}
    showResult(saved.key);
    // La recarga del POST aterriza arriba del todo y el resultado queda bajo
    // el pliegue: «el quiz me sigue mandando al home» (revision 2026-08-12).
    // Salto instantaneo —no suave, ver bl-slider.js— y foco en la ficha
    // ganadora, que es ademas lo que un lector de pantalla necesita.
    if (results) {
      results.scrollIntoView({ behavior: 'auto', block: 'start' });
      var ganadora = section.querySelector('.bl-quiz__outcome.is-match') || results;
      ganadora.setAttribute('tabindex', '-1');
      ganadora.focus({ preventScroll: true });
    }
    return;
  }
  if (root.querySelector('[data-bl-lead-errors]') && saved) {
    // el form volvio con errores: directo al paso de contacto, lead repuesto
    if (leadAnswers) leadAnswers.value = saved.labels.join(' | ');
    if (leadResult) leadResult.value = saved.key === 'mixed' ? 'Mixed' : titleFor(saved.key);
    i = total;
    render();
    // mismo aterrizaje: que el error se vea, no la cabecera de la pagina
    root.scrollIntoView({ behavior: 'auto', block: 'start' });
    return;
  }

  render();
});

  } catch(e) { console.error(e); }
})();
})();
